import { THEME_URL } from './constants.js';

// Header toggle functionality
export function toggleHeader() {
  // site-header toggle is-white-bg
  const header = document.querySelector('.site-header');
  const searchIcon = document.querySelector('.search-button img');
  const customLogoLink = document.querySelector('.custom-logo-link img');
  if (header.classList.contains('is-white-bg')) {
    header.classList.remove('is-white-bg');
    searchIcon.src = THEME_URL + '/images/icon-search.svg';
    customLogoLink.src = THEME_URL + '/images/logo-empower-analog/logo.svg';
  } else {
    header.classList.add('is-white-bg');
    searchIcon.src = THEME_URL + '/images/logo-empower-analog/icon-search-dark.svg';
    customLogoLink.src = THEME_URL + '/images/logo-empower-analog/logo-dark.svg';
  }
}
